import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstcfb: [],
		cfb: null,
		insert: false,
		update: false,
		loading: false,
		searchParams: {
			search: "",
			since: "",
			until: "",
			cfbcliente: "",
			limit: 20,
		},
		hasNext: false,
	},
	getters: {},
	mutations: {
		set(state, cfb) {
			state.cfb = cfb
			if (!state.cfb) {
				state.insert = true
				state.update = false

				state.cfb = {
					cf3estado: "",
					cf3nome: "",
					cfbcepent: "",
					cfbendent: "",
					cfbproximo: "",
					cfbcliente: state.searchParams.cfbcliente,
				}
			}
			if (state.cfb.cfbcliente && state.cfb.cfbid) {
				state.update = true
				state.insert = false
			}
		},
		setCfbPrincip(state, val) {
			state.cfb.cfbprincip = val
		},
		setParamsDataTable(state, payload) {
			state.lstcfb = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		async find(store, { cfbcliente, cfbid, isSilent = false }) {
			if (!cfbcliente || !cfbid || cfbcliente === 'null' || cfbid === 'null') return null
			store.state.loading = true
			try {
				return await this._vm.$axios.get(`/Customer/ShippingAddress/Find/${cfbcliente}/${cfbid}`).then(response => {
					const cfb = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cfb)
					return cfb
				})
			} catch (error) {
				if(!isSilent) {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				}
			} finally {
				store.state.loading = false
			}
		},
		async save(store) {
			if (store.state.update) {
				return await store.dispatch("update")
			}
			return await store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			try {
				return await this._vm.$axios.post("/Customer/ShippingAddress/Insert", store.state.cfb).then(async response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", data)
					await store.dispatch("search", {})
					return data
				})
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return false
			} finally {
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			try {
				return await this._vm.$axios.put("/Customer/ShippingAddress/Update", store.state.cfb).then(async response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", data)
					await store.dispatch("search", {})
					return data
				})
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return false
			} finally {
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Customer/ShippingAddress/Delete/${store.state.cfb.cfbcliente}/${store.state.cfb.cfbid}`)
				.then(async response => {
					Utils.ValidateAxiosResponse(response.data)
					await store.dispatch("search", {})
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			await this._vm.$axios
				.get("/Customer/ShippingAddress/FindList")
				.then(response => {
					let lstcfb = Utils.ValidateAxiosResponse(response.data)
					store.state.lstcfb = lstcfb
					store.state.hasNext = lstcfb.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstcfb = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
		},
		async search({ state, dispatch, commit }, { page = 1 }) {
			state.loading = true

			const params = {
				...state.searchParams,
				page,
			}

			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddress/Search", { params })
				const payload = Utils.ValidateAxiosResponse(response.data)
				commit("setParamsDataTable", payload)
				return true
			} catch (error) {
				state.lstcfb = []
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return false
			} finally {
				state.loading = false
			}
		},
		async findAllCustomersWithAddress({ dispatch }, { text = "" }) {
			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddress/FindCustomersWithAddresses", {
					params: {
						search: text
					},
				})
				return Utils.ValidateAxiosResponse(response.data)
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			}
		},
		async changeMainAddress(store, { proceed = false }) {
			if (!store.state.cfb.cfbprincip) return
			if (store.state.cfb.cfbmelvcto) {
				store.state.cfb.cfbmelvcto = store.state.cfb.cfbmelvcto.toString()
			}

			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: `${proceed ? "Salvando" : "Validando"}`, indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.get("/Customer/ShippingAddress/CanSetNewMainAddress", {
					params: {
						proceed: proceed,
						cfbid: store.state.cfb.cfbid,
						cfbcliente: store.state.cfb.cfbcliente,
						cfbprincip: store.state.cfb.cfbprincip,
					},
				})
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					if (!data.success) {
						store.dispatch(
							"parameters/openDialog",
							{
								titleText: "Aviso",
								titleColor: "#f8bb86",
								text: data.confirmationMessage,
								confirmBtn: true,
								confirmText: "Sim",
								confirmAction: () => store.dispatch("changeMainAddress", { proceed: true, checkboxNewState: true }),
								cancelAction: () => store.commit("setCfbPrincip", !store.state.cfb.cfbprincip),
								cancelText: "Não",
							},
							{ root: true },
						)
					}
				})
				.catch(error => {
					store.commit("setCfbPrincip", !store.state.cfb.cfbprincip)
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
				.finally(() => {
					store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
				})
		},

		async getAddressessForGroup(store, { cfhid = null, cfhcliente = null }) {
			store.state.loading = true

			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddress/GetAddressessForGroup", {
					params: {
						cfhid: cfhid,
						cfbcliente: cfhcliente,
					},
				})
				return Utils.ValidateAxiosResponse(response.data)
			} catch (error) {
				store.state.lstcfb = []
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			} finally {
				store.state.loading = false
			}
		},
		async findListByCustomer(store, { cfbcliente, text = "", fieldsToReturn = [] }) {
			if (!cfbcliente || cfbcliente === 'null') return []
			store.state.loading = true

			try {
				const response = await this._vm.$axios.get(`/Customer/ShippingAddress/FindListByCustomer/${cfbcliente}`, {
					params: { search: text }
				})

				const data = Utils.ValidateAxiosResponse(response.data) || []
				return Utils.PickProps(data, fieldsToReturn)
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			} finally {
				store.state.loading = false
			}
		},
	},
}
